import axios from "axios";
import { API_BASE_URL } from "../config/config.js";

// The CSRF token lives in memory only - never in localStorage/sessionStorage.
// The session itself is the HttpOnly session_id cookie, which JS can't read.
let csrfToken = null;

export const getCsrfToken = () => csrfToken;

/** Ask the backend who is logged in. A 401/network error counts as logged out. */
export async function fetchSession() {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/auth/session`, {
      withCredentials: true,
    });
    csrfToken = data?.authenticated ? data.csrf_token : null;
    return data;
  } catch (e) {
    csrfToken = null;
    return { authenticated: false };
  }
}

/** Full-page redirect: backend -> Entra -> backend callback -> back to the app. */
export function login() {
  window.location.assign(`${API_BASE_URL}/auth/login`);
}

export async function logout() {
  try {
    // X-CSRF-Token is added by the interceptor in setupAxios.js
    await axios.post(`${API_BASE_URL}/auth/logout`, null, { withCredentials: true });
  } finally {
    csrfToken = null;
    window.location.assign("/");
  }
}